import Highcharts from 'highcharts';

export const tailwindColorMap = {
  ok: 'rgba(54, 199, 153, 0.2)',
  info: 'rgba(134, 221, 193, 0.2)',
  warning: 'rgba(252, 199, 89, 0.2)',
  critical: 'rgba(255, 104, 104, 0.2)',
};

export interface ReferenceArea {
  lower: number; // e.g., for Y-axis from
  upper: number; // e.g., for Y-axis to
  state: 'ok' | 'info' | 'warning' | 'critical';
}

export const getReferencePlotBands = (
  referenceAreas: ReferenceArea[],
): Highcharts.YAxisPlotBandsOptions[] => {
  return referenceAreas.map((refArea) => {
    let color = tailwindColorMap.ok;
    let labelText = 'OK';

    if (refArea.state === 'info') {
      color = tailwindColorMap.info;
      labelText = 'Info';
    } else if (refArea.state === 'warning') {
      color = tailwindColorMap.warning;
      labelText = 'Warning';
    } else if (refArea.state === 'critical') {
      color = tailwindColorMap.critical;
      labelText = 'Critical';
    }

    return {
      from: refArea.lower,
      to: refArea.upper,
      color,
      opacity: 0.2,
      label: {
        text: labelText,
        zIndex: 20,
        style: {
          color: '#374151', // some neutral text color
          fontWeight: 'bold',
        },
      },
    };
  });
};
